module.exports = require("gsap/umd/TweenMax");


//////////////////
// WEBPACK FOOTER
// external "gsap/umd/TweenMax"
// module id = 20
// module chunks = 0